export default __webpack_public_path__ + "static/media/location-disabled.a495f5e4.svg";